// =============================================================
// ŞAFAK · presentation — tam kadraj sinematik açılış
// Konsept: full-bleed sahne + alçalan "kapı kartı" paneli +
// dev hayalet bölüm numarası. Mimari plan: semantic, readable.
// =============================================================

import { useRef } from "react";
import { LinkButton } from "@/components/ui/Button";
import { COPY } from "@/features/landing/content/landing-copy";
import { useSafakMotion } from "./Safak.motion";
import styles from "./Safak.module.css";

export function Safak() {
  const scopeRef = useRef<HTMLElement | null>(null);
  useSafakMotion(scopeRef);

  return (
    <section
      ref={scopeRef}
      id="safak"
      className={styles.safak}
      aria-labelledby="safak-title"
    >
      {/* ── Full-bleed sahne + kontrast scrim ──────────────── */}
      <div className={styles.safak__stage} aria-hidden="true">
        <img
          src="/media/hero-bg.jpg"
          alt=""
          width={2400}
          height={1600}
          loading="eager"
          // @ts-ignore React 19
          fetchpriority="high"
          decoding="async"
        />
        <div className={styles.safak__scrim} />
      </div>

      {/* ── Hayalet bölüm numarası ────────────────────────── */}
      <span className={styles.safak__ghost} aria-hidden="true">{COPY.safak.chapterShort}</span>

      {/* ── Kapı kartı: başlık + sub + CTA + meta ─────────── */}
      <div className={styles.safak__panel}>
        <p className={styles.safak__eyebrow}>{COPY.safak.chapter} · {COPY.safak.eyebrow}</p>

        <h1 className={styles.safak__title} id="safak-title">
          {COPY.safak.titleTokens.map((tok, i) => (
            <span key={i} className="word">
              {tok.italic ? <em>{tok.text}</em> : tok.text}
            </span>
          ))}
        </h1>

        <p className={styles.safak__sub}>{COPY.safak.sub}</p>

        <div className={styles.safak__actions}>
          <LinkButton href={COPY.safak.ctaPrimary.href} variant="primary" size="lg">
            {COPY.safak.ctaPrimary.label}
            <svg className="btn__icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path d="M3 8h10M9 4l4 4-4 4" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </LinkButton>
          <LinkButton href={COPY.safak.ctaSecondary.href} variant="ghost" size="lg" ariaLabel="Telefonla ara">
            {COPY.safak.ctaSecondary.label}
          </LinkButton>
        </div>

        <dl className={styles.safak__meta}>
          {COPY.safak.meta.map((m) => (
            <div key={m.label} className={styles["safak__meta-row"]}>
              <dt>{m.label}</dt>
              <dd>{m.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
